import React, {
  CSSProperties,
  FC,
} from 'react';
import { useCookies } from 'react-cookie';
import {
  Row, Button, Column,
} from './Styles';
import { languageChange } from '../../../../assets/Svg';
import TempFieldUtils from '../../../../lib/TempFieldUtils';
import { isMobile } from '../../../../lib/utils/utils';

const LanguageButton: FC<Props> = ({
  isEnglish,
  setIsEnglish,
  languageColor,
  languageIcon,
  style,
}) => {
  const [cookies, setCookie] = useCookies(['fox_h5_language']);

  return (
    <Button
      onClick={() => {
        // Cookies
        setCookie("fox_h5_language", !isEnglish ? 'EN' : 'CN', { expires: new Date((new Date().getTime()) + 1000 * 60 * 60 * 24 * 365), path: "/" });
        // localStorage
        localStorage.setItem('fox_h5_language', !isEnglish ? 'EN' : 'CN');
        // 切换中英文
        TempFieldUtils.currentIsEnglish = !isEnglish;
        setIsEnglish(!isEnglish);
      }}
      style={{ marginRight: isMobile() ? 20 : undefined, ...style }}
    >
      <Row style={{ height: '20px' }}>
        <Column>
          <img src={languageIcon || languageChange} style={{ width: '12px', height: '11px' }} />
        </Column>
        {
          isEnglish ? (
            <Column style={{ width: '40px', marginLeft: '5px', fontSize: '16px', fontFamily: 'PingFangSC-Medium, PingFang SC', fontWeight: 500, color: languageColor || '#11202B', alignItems: 'flex-start' }}>
              中文
            </Column>
          ) : (
            <Column style={{ width: '40px', marginLeft: '5px', marginTop: '2px', fontSize: '16px', fontFamily: 'Squad-SemiBold, Squad', fontWeight: 600, color: languageColor || '#11202B', alignItems: 'flex-start' }}>
              EN
            </Column>
          )
        }
      </Row>
    </Button>
  );
};

export interface Props {
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  languageColor?: string;
  languageIcon?: any;
  style?: CSSProperties;
}

export default LanguageButton;
